import React from 'react';

// kind: 'tab' (bottom-bar page), 'view' (native page inside the shell), 'legacy' (existing dashboard section)
export const GROUPS = [
  { title: 'Daily Classroom Essentials', tools: [
    { id: 'attendance', kind: 'tab', icon: '📋', tint: '#dcfce7', label: 'P/A Control', desc: 'Take attendance' },
    { id: 'quickmark', kind: 'legacy', icon: '⚡', tint: '#dcfce7', label: 'Quick-Mark All Classes', desc: 'Mark absentees + WhatsApp queue' },
    { id: 'attendancemaster', kind: 'legacy', icon: '🗂️', tint: '#dcfce7', label: 'Master Attendance & WhatsApp', desc: 'Week/month, past years, holidays, reports' },
    { id: 'homework', kind: 'view', icon: '📝', tint: '#fef9c3', label: 'Classwork & Homework', desc: 'Post daily tasks' },
    { id: 'timetable', kind: 'view', icon: '📅', tint: '#dbeafe', label: 'Timetable', desc: 'Periods & timings' },
    { id: 'diary', kind: 'legacy', icon: '📖', tint: '#ede9fe', label: 'Teacher Diary', desc: 'Notes & chapter log' },
    { id: 'unifieddesk', kind: 'legacy', icon: '🗓️', tint: '#cffafe', label: 'Daily Desk', desc: 'Attendance + diary + homework in one save' },
    { id: 'mycompliance', kind: 'legacy', icon: '📋', tint: '#dcfce7', label: 'My Compliance Card', desc: 'Attendance, diary & punctuality record' },
    { id: 'classanalytics', kind: 'legacy', icon: '📊', tint: '#e0e7ff', label: 'Class Analytics', desc: 'KPIs, trends & student risk matrix' }
  ] },
  { title: 'Academic & Exam Suite', tools: [
    { id: 'papers', kind: 'tab', icon: '📄', tint: '#e0e7ff', label: 'AI Paper Generator', desc: 'Bilingual exam papers' },
    { id: 'qpbuilder', kind: 'legacy', icon: '📝', tint: '#e0e7ff', label: 'Question Paper Builder', desc: 'AI + manual papers, answer key PDF' },
    { id: 'printmarksheet', kind: 'legacy', icon: '🖨️', tint: '#fee2e2', label: 'Marksheets', desc: 'Marks entry & print' },
    { id: 'progress', kind: 'legacy', icon: '📊', tint: '#cffafe', label: 'Progress & Rank', desc: 'Student performance' },
    { id: 'students', kind: 'legacy', icon: '👥', tint: '#fce7f3', label: 'Students', desc: 'Profiles, phone numbers & edit' },
    { id: 'access', kind: 'view', icon: '🔑', tint: '#ede9fe', label: 'Student Account Access', desc: 'Login IDs, reset PIN, view as student', badge: 'Logins' }
  ] },
  { title: 'Content & School Connect', tools: [
    { id: 'notices', kind: 'view', icon: '📢', tint: '#ffedd5', label: 'Announcements', desc: 'Notices to class' },
    { id: 'library', kind: 'legacy', icon: '📚', tint: '#ecfccb', label: 'Library & Links', desc: 'Study material' },
    { id: 'behavior', kind: 'legacy', icon: '🌟', tint: '#fef3c7', label: 'Behavior Log', desc: 'Conduct remarks' }
  ] },
  { title: 'More Tools', tools: [
    { id: 'classrank', kind: 'legacy', icon: '🏆', tint: '#fef9c3', label: 'Class Rank', desc: '' },
    { id: 'professionalmarksheet', kind: 'legacy', icon: '🎓', tint: '#fee2e2', label: 'Report Card', desc: '' },
    { id: 'content', kind: 'legacy', icon: '🗂️', tint: '#e0f2fe', label: 'Content', desc: '' },
    { id: 'online', kind: 'legacy', icon: '💻', tint: '#ede9fe', label: 'Online Content', desc: '' },
    { id: 'courselinks', kind: 'legacy', icon: '🔗', tint: '#dbeafe', label: 'Course Links', desc: '' },
    { id: 'myattendance', kind: 'legacy', icon: '🗓️', tint: '#dcfce7', label: 'My Attendance', desc: '' },
    { id: 'ranking', kind: 'legacy', icon: '⭐', tint: '#fef3c7', label: 'My Ranking', desc: '' },
    { id: 'visibility', kind: 'legacy', icon: '👁️', tint: '#f1f5f9', label: 'P/A Visibility', desc: '' },
    { id: 'games', kind: 'legacy', icon: '🎮', tint: '#fce7f3', label: 'Games', desc: '' }
  ] }
];

function TeacherToolGrid({ onPick, isTeacherAdmin }) {
  const groups = isTeacherAdmin
    ? GROUPS.map((g) => (g.title === 'More Tools'
      ? { ...g, tools: [...g.tools, { id: 'superteacher', kind: 'legacy', icon: '🛡️', tint: '#e2e8f0', label: 'Super Teacher', desc: '' }] }
      : g))
    : GROUPS;
  return (
    <>
      {groups.map((g) => (
        <section key={g.title} className="th-group">
          <h2 className="th-group-title">{g.title}</h2>
          <div className="th-grid">
            {g.tools.map((t) => (
              <button key={t.id} className="th-tile" onClick={() => onPick(t)}>
                <span className="th-tile-icon" style={{ background: t.tint }}>{t.icon}</span>
                <span className="th-tile-label">{t.label}</span>
                {t.desc && <span className="th-tile-desc">{t.desc}</span>}
                {t.badge && <span className="th-badge">{t.badge}</span>}
              </button>
            ))}
          </div>
        </section>
      ))}
    </>
  );
}

export default TeacherToolGrid;
